module.exports = __webpack_public_path__ + "img/verified.2bab04f9.svg";